module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_revivallabs_m.28fac0fe453f01c345fdf1b553688903.png";